import {useCallback, useLayoutEffect, useRef} from 'react'

/**
 * Returns a function with a stable identity that always invokes the latest
 * callback. Pass the result to memoized children (React.memo / React Compiler
 * memoization) so inline handler props don't force them to re-render.
 * The returned function must not be called during render.
 */
export function useStableCallback<T extends (...args: any[]) => any>(fn: T): T {
  const ref = useRef(fn)

  useLayoutEffect(() => {
    ref.current = fn
  })

  return useCallback(((...args: any[]) => ref.current(...args)) as T, [])
}

export default useStableCallback
